import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';

import HorseShares from './HorseShares';

import {
  Spinner,
} from '../../../../components';

import {
  fetchSyndicationsInitData,
  saveSyndication,
} from './actions';

const HorseSharesContainer = () => {

  const { horseId } = useParams();

  const [ dataSyndications, setDataSyndications ] = useState([]);
  const [ dataCustomers, setDataCustomers ] = useState([]);

  // Loading states
  const [ isLoading, setIsLoading ] = useState(true);
  const [ isSaving, setIsSaving ] = useState(false);

  useEffect(() => {
    _initData();
  }, []);

  const _initData = async () => {
    const result = await fetchSyndicationsInitData(horseId);
    _splitRecords(result);
    setIsLoading(false);
  }

  const _splitRecords = (records) => {
    setDataCustomers(records.customers);
    setDataSyndications(records.syndications);
  }

  // Syndication CURD
  const handleSyndicationCreate = async (data) => {
    setIsSaving(true);
    await _saveSyndication(data);
    setIsSaving(false);
  }

  const handleSyndicationDelete = async (data) => {
    await _saveSyndication(data, 'delete');
  }

  const _saveSyndication = async (data, method) => {
    const result = await saveSyndication({ ...data, horseId }, method);
    _splitRecords(result);
  }

  return (
    isLoading ?
      <Spinner /> :
      <HorseShares
        dataCustomers={dataCustomers}
        dataSyndications={dataSyndications}
        isLoading={isLoading}
        isSaving={isSaving}
        onCreate={handleSyndicationCreate}
        onDelete={handleSyndicationDelete}
      />
  );
}

export default HorseSharesContainer;
